export const ACTIVITY_LOG_EVENTS = {
  // 檢視 v1, v2 Speaking 課程詳細頁
  Speaking: {
    eventTypeId: '66e2b9008254f24941876232',
    description: 'In a Speaking class right now'
  },
  // 檢視 v1, v2 Writing 課程詳細頁
  Writing: {
    eventTypeId: '66e2b90d8254f24941876233',
    description: 'In a Writing class right now'
  },
  // 檢視 v1, v2 Reading 列表細頁
  Reading: {
    eventTypeId: '66e2c61c8254f24941876238',
    description: 'Reading Article'
  },
  // 登入動作
  LogIn: {
    eventTypeId: '66f4d3fb585787fadefd796c',
    description: 'Log In'
  },
  // 登出動作
  LogOut: {
    eventTypeId: '66f4d40c585787fadefd796d',
    description: 'Log Out'
  },
  // 進入電銷問卷
  ViewQuestionnaire: {
    eventTypeId: '67513ded862aa08f74ca53e8',
    description:
      'After completing the level selection form, the user will encounter a sales questionnaire if the registration date is within the past 10 days.'
  },
  // 跳過電銷問卷
  SkipQuestionnaire: {
    eventTypeId: '67513e0d862aa08f74ca53eb',
    description: 'User skip the sales questionnaire'
  },
  // 完成電銷問卷
  CompleteQuestionnaire: {
    eventTypeId: '67513e64862aa08f74ca53f1',
    description: 'User complete the sales questionnaire'
  },
  // 檢視 v1, v2 Speaking 列表頁
  ViewSpeaking: {
    eventTypeId: '678f1739862aa08f74cc0d61',
    description: 'Stayed on the speaking list page for more than 10 seconds'
  },
  // 檢視 v1, v2 Writing 列表頁
  ViewWriting: {
    eventTypeId: '678f1745862aa08f74cc0d62',
    description: 'Stayed on the writing list page for more than 10 seconds'
  },
  // 檢視 v1, v2 Reading 內容頁的研讀文本
  ViewArticle: {
    eventTypeId: '6a4dea53e89ceadde65d2379',
    description: 'ActivityLog.ViewArticle.description'
  },
  // 完成 Reading 各項「功能項目」測驗 (評級 A~D 寫入，低於 D 不計入)
  CompleteArticleQuiz: {
    eventTypeId: '6a4dea53e89ceadde65d237a',
    description: 'ActivityLog.CompleteArticleQuiz.description'
  },
  // 檢視 Reading 內容頁的 AI 會話
  ViewAIConversation: {
    eventTypeId: '6a4dea53e89ceadde65d237b',
    description: 'ActivityLog.ViewAIConversation.description'
  },
  // 檢視 Reading 內容頁的 AI 朗讀
  ViewAIReading: {
    eventTypeId: '6a4dea53e89ceadde65d237c',
    description: 'ActivityLog.ViewAIReading.description'
  },
  // 檢視 Reading 內容頁的 AI 寫作
  ViewAIWriting: {
    eventTypeId: '6a4dea53e89ceadde65d237d',
    description: 'ActivityLog.ViewAIWriting.description'
  },
  // 檢視 v1, v2 直播列表頁
  ViewLiveRoom: {
    eventTypeId: '6a4dea53e89ceadde65d237e',
    description: 'ActivityLog.ViewLiveRoom.description'
  },
  // 進入 v1, v2 直播間
  JoinLiveRoom: {
    eventTypeId: '6a4dea53e89ceadde65d237f',
    description: 'ActivityLog.JoinLiveRoom.description'
  },
  // 課程列表頁 - 點擊「單一課程」事件
  ViewCourse: {
    eventTypeId: '6a4dea53e89ceadde65d2380',
    description: 'ActivityLog.ViewCourse.description'
  },
  // v1, v2 課程詳細頁 - 加入課程事件
  JoinCourse: {
    eventTypeId: '6a4dea53e89ceadde65d2381',
    description: 'ActivityLog.JoinCourse.description'
  },
  // 點擊 「AI 助教」事件
  ViewAITutor: {
    eventTypeId: '6a4dea53e89ceadde65d2382',
    description: 'ActivityLog.ViewAITutor.description'
  },
  // 檢視 v1, v2 多益測驗頁
  ViewNewTOEIC: {
    eventTypeId: '6a4dea53e89ceadde65d2384',
    description: 'ActivityLog.ViewNewTOEIC.description'
  },
  // 完成 v1, v2 多益測驗
  CompleteNewTOEICQuiz: {
    eventTypeId: '6a4dea53e89ceadde65d2385',
    description: 'ActivityLog.CompleteNewTOEICQuiz.description'
  },
  // 檢視 v1, v2 大課表頁
  ViewSchedule: {
    eventTypeId: '6a4dea53e89ceadde65d2386',
    description: 'ActivityLog.ViewSchedule.description'
  },
  // 點擊「教學中心」事件
  ViewTeachingCenter: {
    eventTypeId: '6a4dea53e89ceadde65d2387',
    description: 'ActivityLog.ViewTeachingCenter.description'
  },
  // 檢視學習心得頁
  ViewStudentSharing: {
    eventTypeId: '6a4dea53e89ceadde65d2388',
    description: 'ActivityLog.ViewStudentSharing.description'
  },
  // 檢視 v2 訂閱頁
  ViewSubscriptionPage: {
    eventTypeId: '6a4dea53e89ceadde65d2389',
    description: 'ActivityLog.ViewSubscriptionPage.description'
  }
} as const;
